import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TenantHeroImageComponent } from '../tenant-hero-image/tenant-hero-image.component';

@Component({
  selector: 'app-league-page-hero',
  standalone: true,
  imports: [CommonModule, RouterModule, TenantHeroImageComponent],
  templateUrl: './league-page-hero.component.html',
  styleUrls: ['./league-page-hero.component.css'],
})
export class LeaguePageHeroComponent {
  @Input() title = 'Schedule';
  @Input() subtitle = 'View all upcoming games, locations, and matchups.';
  @Input() links = [

    { label: 'Schedule', link: '/league/schedule' },
    { label: 'Results', link: '/league/results' },
    { label: 'Playoffs', link: '/league/playoffs' },
    { label: 'Standings', link: '/league/standings' },
    { label: 'Leaderboard', link: '/league/leaderboard' },
    { label: 'Teams', link: '/league/teams' },
  ];
}
